<template>
  <div v-if="showComponent">
    <vs-card class="mt-4">
      <div slot="header">
        <h3>Custo do Evento do Patrimônio</h3>
      </div>

      <div class="vx-row">
        <!-- Número Orçamento -->
        <div class="vx-col lg:w-1/4 w-full mb-2">
          <vs-input
            class="w-full"
            label="Número Orçamento"
            name="Número Orçamento"
            v-model="formCustoEvento.nrOrcamento"
          />
        </div>

        <!-- Custo do Evento -->
        <div class="vx-col lg:w-1/4 w-full mb-2">
          <label class="vs-input--label">Custo do Evento</label>
          <money
            class="w-full vs-inputx vs-input--input moneyStyle"
            v-model="formCustoEvento.custoReparo"
            name="Custo do Evento"
            v-bind="moneyConfig"
          />
        </div>

        <!-- Previsão de Valor de Reparo -->
        <div class="vx-col lg:w-1/4 w-full mb-2">
          <label class="vs-input--label">Previsão de Valor de Reparo</label>
          <money
            class="w-full vs-inputx vs-input--input moneyStyle"
            v-model="formCustoEvento.previsaoValorReparo"
            name="Previsão de Valor de ReparoState"
            v-bind="moneyConfig"
          />
        </div>
      </div>
    </vs-card>
  </div>
</template>

<script>
import { Money } from 'v-money';

export default {
  props: ['formData'],
  components: { Money },
  watch: {
    formData(value) {
      if (!value.custoEvento) {
        this.showComponent = false;
        console.error(
          'ERRO NO CONTRATO DO OBJETO - CUSTO EVENTO TERCEIRO FORM',
        );
        return;
      }

      this.formCustoEvento = Object.assign(
        this.formCustoEvento,
        value.custoEvento,
      );

      // eslint-disable-next-line vue/no-mutating-props
      this.formData.custoEvento = this.formCustoEvento;
    },
  },
  data() {
    return {
      showComponent: true,
      formCustoEvento: {
        nrOrcamento: null,
        custoReparo: 0,
        previsaoValorReparo: 0,
      },

      // Configurações de Component
      moneyConfig: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
      },
    };
  },
  mounted() {
    if (!this.formData.custoEvento) {
      console.error('ERRO NO CONTRATO DO OBJETO - CUSTO EVENTO TERCEIRO FORM');
      this.showComponent = false;
    }

    // eslint-disable-next-line vue/no-mutating-props
    this.formData.custoEvento = this.formCustoEvento;
  },
};
</script>

<style scoped>
.moneyStyle {
  font-size: 1rem !important;
  padding: 0.7rem !important;
}
</style>
